import {GET_CURRENT_WEATHER_ERROR} from "../../reducers/weatherReducer";

export const getCurrentWeatherError = (error) =>{
    return {
        type: GET_CURRENT_WEATHER_ERROR,
        payload: {error}
    }
}